import {useContext} from 'react'

import Context from '@s-ui/react-context'
import IconArrowRight from '@adv-mt/mt-svg-icons/lib/ArrowRight.js'
import {Button, BUTTON_INTENTS, BUTTON_SHAPES, BUTTON_SIZES, BUTTON_VARIANTS} from '@adv-mt/ui/button'
import {Icon, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1} from '@adv-mt/ui/typography'

import {BASE_CLASS} from './FormFields.js'

const AppraisalCrossSell = () => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const {INSTANT_OFFER_STANDALONE_PATTERN} = config.get('page')
  const {C2B_ORIGINS} = config.get('c2b')

  if (!INSTANT_OFFER_STANDALONE_PATTERN) {
    return null
  }

  return (
    <div className={`${BASE_CLASS}-crossSell`}>
      <div className={`${BASE_CLASS}-crossSellCopy`}>
        <Body1 className={`${BASE_CLASS}-crossSellTitle`} highlight>
          {i18n.t('CONTACT_SELLER_V2.CROSS_SELL.TITLE')}
        </Body1>
        <Body1 className={`${BASE_CLASS}-crossSellBody`}>{i18n.t('CONTACT_SELLER_V2.CROSS_SELL.BODY')}</Body1>
      </div>
      <Button
        href={`${INSTANT_OFFER_STANDALONE_PATTERN}?ipromo=c2b-detail-post_lead_button&origin=${C2B_ORIGINS.POST_LEAD}`}
        variant={BUTTON_VARIANTS.OUTLINE}
        intent={BUTTON_INTENTS.PRIMARY}
        size={BUTTON_SIZES.MEDIUM}
        shape={BUTTON_SHAPES.CIRCLE}
      >
        {i18n.t('CONTACT_SELLER_V2.CROSS_SELL.CTA')}
        <Icon className={`${BASE_CLASS}-crossSellCtaIcon`} size={ICON_SIZES.MD}>
          <IconArrowRight size={ICON_SIZES.MD} />
        </Icon>
      </Button>
    </div>
  )
}

AppraisalCrossSell.displayName = 'ContactFormV2AppraisalCrossSell'

export default AppraisalCrossSell
